/* global NProgress */

Wee.fn.make('common', {
	init: function() {
		var priv = this.$private;

		priv.initHistory();
		priv.initEvents();

		NProgress.configure({
			showSpinner: false
		});
	},

	alert: function() {
		var scope = this;

		Wee.alert.top({
			cookieEnabled: false,
			cycleDelay: 5,
			enabledCallback: function() {
				scope.$private.calculatePosition();
			},
			disabledCallback: function() {
				var height,
					size = Wee.screen.size();

				scope.$private.calculatePosition();

				if (size > 3) {
					height = 655;
				} else if (size === 3) {
					height = 955;
				} else if (size < 3) {
					height = 600;
				}

				Wee.animate.tween('ref:homepageHero', {
					height: height
				});
			}
		});
	}
}, {
	initHistory: function() {
		var loadTimer;

		// Wee history
		$.history.init({
			bind: {
				click: 'a'
			},
			request: {
				send: function() {
					NProgress.start();

					loadTimer = setInterval(function() {
						NProgress.inc();
					}, 600);
				},
				complete: function() {
					clearInterval(loadTimer);

					NProgress.done();
				},
				error: function(xhr) {
					$._win.location = xhr.responseURL;
				}
			},
			end: function() {
				ga('set', 'page', Wee.routes.uri().full);
				ga('send', 'pageview');
			}
		});

		// Disable mouse event outlines
		$('a').on('mousedown', function() {
			var $el = $(this);

			if ($el.css('outline-style') == 'none') {
				var outlineClass = '-no-outline';

				$el.addClass(outlineClass).on('blur', function() {
					$el.removeClass(outlineClass);
				}, {
					once: true
				});
			}
		}, {
			delegate: $._body
		});
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		$.events.on({
			'ref:recSearchItem': {
				click: function() {
					$('ref:body').deactivate();
					$('ref:header').deactivate();
				}
			}
		}, {
			delegate: $._body
		});
	},

	/**
	 * Calculate top positioning for mobile nav
	 *
	 * @private
	 */
	calculatePosition: function() {
		var $mobileNav = $('ref:mobileNav'),
			height = ($('ref:header').height() + $('ref:weeTopAlert').height()) + 'px';

		$mobileNav.css('top', height);
	}
});
